import "./LandingPage.css";
import MainLanding from "../../../img/main-landing.png";
import { Link } from "react-router-dom";
import { Button } from "antd";
import useAuthorizationData from "../../../utils/useAuthorizationData";

const VisitList = () => {
  const [authorizationData] = useAuthorizationData();
  
  return (
    <>
      <div className="landing-page">
        <img src={MainLanding} className="landing-page-image" alt="" />
      </div>
      <div className="landing-page-text-block">
        <p className="landing-page-title">
        WELCOME TO OUR <strong>VISITORS HANDLING PORTAL</strong>
        </p>
        <p className="landing-page-title-desc">PHOENIX REISEN GMBH - FLEET MANAGEMENT</p>
        <Button type="primary" size="large">
          {authorizationData == null ? (
            <Link to="/login" className="header-link">
              LOGIN/REGISTER
            </Link>
            ) : (
            <Link to="/addvisit" className="header-link">
              BOOK YOUR VISIT
            </Link>
          )}
        </Button>
      </div>
      <div className="landing-page-footer">
          <p className="landing-page-footer-desc-medium">Phoenix Reisen GmbH - Fleet Management</p>
          <p className="landing-page-footer-desc-small">Impressum - Datenschutzbestimmungen</p>
        </div>
    </>
  );
};

VisitList.displayName = "Landing Page";

export default VisitList;
